import React from 'react';
import { Filter } from 'lucide-react';
import * as Popover from '@radix-ui/react-popover';
import { Checkbox } from '../../ui/Checkbox';

interface FilterOption {
  value: string;
  label: string;
  color?: string;
}

interface FilterSection {
  title: string;
  options: FilterOption[];
  selectedValues: string[];
  onValueChange: (value: string, checked: boolean) => void;
}

interface FilterButtonProps {
  sections: FilterSection[];
  onReset: () => void;
}

export const FilterButton: React.FC<FilterButtonProps> = ({ sections, onReset }) => {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <button className="flex items-center space-x-2 px-4 py-2 bg-[#1A1F2E] border border-gray-800 rounded-lg text-gray-300 hover:bg-[#1A1F2E]/80 transition-colors group">
          <Filter className="h-4 w-4 text-gray-500 group-hover:text-gray-400" />
          <span className="text-sm">Filters</span>
        </button>
      </Popover.Trigger>

      <Popover.Portal>
        <Popover.Content
          className="w-80 bg-[#1A1F2E] rounded-lg border border-gray-800 shadow-xl animate-in fade-in-0 zoom-in-95"
          sideOffset={8}
        >
          <div className="p-4 space-y-6">
            {sections.map((section, index) => (
              <div key={index} className="space-y-3">
                <h3 className="text-sm font-medium text-gray-400">{section.title}</h3>
                <div className="space-y-2">
                  {section.options.map((option) => (
                    <label
                      key={option.value}
                      className="flex items-center space-x-2 cursor-pointer group/option"
                    >
                      <Checkbox
                        checked={section.selectedValues.includes(option.value)}
                        onCheckedChange={(checked) => 
                          section.onValueChange(option.value, !!checked)
                        }
                      />
                      <span className={`text-sm ${option.color || 'text-gray-300'} group-hover/option:text-white transition-colors`}>
                        {option.label}
                      </span>
                    </label>
                  ))}
                </div>
              </div>
            ))}

            <div className="pt-4 border-t border-gray-800 flex justify-end">
              <button
                onClick={onReset}
                className="text-sm text-gray-400 hover:text-white transition-colors"
              >
                Reset Filters
              </button>
            </div>
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};